import * as React from "react";

type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

type AvatarProps = {
    name: string;
    imageUrl?: string | null;
    size?: AvatarSize;
    className?: string;
};

const sizeClasses: Record<AvatarSize, { container: string; text: string }> = {
    xs: { container: 'h-8 w-8', text: 'text-xs' },
    sm: { container: 'h-10 w-10', text: 'text-sm' },
    md: { container: 'h-12 w-12', text: 'text-lg' },
    lg: { container: 'h-16 w-16 sm:h-24 sm:w-24', text: 'text-2xl sm:text-4xl' },
    xl: { container: 'h-24 w-24 sm:h-32 sm:w-32', text: 'text-4xl sm:text-5xl' },
};

const Avatar: React.FC<AvatarProps> = ({ name, imageUrl, size = 'md', className = '' }) => {
    const initial = name.charAt(0).toUpperCase();
    const { container, text } = sizeClasses[size];

    if (imageUrl) {
        return (
            <img
                src={imageUrl}
                alt={name}
                className={`${container} rounded-full object-cover ${className}`}
            />
        );
    }

    return (
        <span className={`inline-flex items-center justify-center rounded-full bg-red-600 ${container} ${className}`}>
            <span className={`${text} font-bold leading-none text-white`}>
                {initial}
            </span>
        </span>
    );
};

export default Avatar;
